import React from "react";
import { IconButton, Dialog, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ccLogo from "../../../images/cc.png";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ActionButton from "../button/actionButton";

const PaymentAdvisoryModal = ({ isOpen, handleClose }) => {
  const closeDialog = () => {
    handleClose();
  }; 

  return (
    <Dialog
      open={isOpen}
      maxWidth="sm"
      fullWidth
      sx={{ textAlign: "center" , marginBottom:"10px"}}
      PaperProps={{
        style: {
          padding: "10px",
          width: "432px",
          borderRadius: "20px",
        },
      }}
    >
      <Box sx={{ textAlign: "right", marginRight: "10px"  }}>
        <IconButton onClick={closeDialog}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box>
        <img src={ccLogo} style={{ width: "67px", height: "67px" }} />
      </Box>
      <DialogTitle id="alert-dialog-title">
         <Typography variant="h6" fontWeight={600} fontSize="20px" color="#111111">
          Payment Process Update
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description"  sx={{ textAlign: "center" }}>
          <Typography variant="h6" fontWeight={500} fontSize="16px" color="#111111" sx={{ px: "32px" }} >
              To improve our service, we're updating how payments are handled.
              {<br />}
              {<br />}
              Starting {" "}
                <Box component="span" fontWeight={700} fontSize="16px" >
                  August 11, 2025 
                </Box>
              , your credit card will be automatically charged as soon as the design is completed.
              {<br />}
              {<br />}
              <Box component="span" fontWeight={700} fontSize="16px" >
                To ensure a seamless transition 
              </Box>
              {" "} and avoid any disruptions, please take a moment to confirm your payment details are up to date.
              {<br />}
              {<br />} 
          </Typography>
         
          <Box sx={{ textAlign:"center", marginBottom: "10px", marginRight: "10px"}}>
            <ActionButton  
              color="brand" 
              onClick = {() => window.location.href = '/paymentDetails' } 
              sx={{
                fontSize: "15px",  
                fontWeight: 500,
                borderRadius: "10px", 
                width: "215px",
                height: "44px"
              }}
            >
              Confirm Payment Details
            </ActionButton>
          </Box>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentAdvisoryModal;
